import { Column, Index } from 'typeorm';
import type { TradeShowBudgetLineKey } from '../../constants/trade-shows';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';

/**
 * What a tenant entered for one line of a show's budget (PD-17635). Everything
 * else on the budget is worked out from the directory and Team and Travel, so
 * there is a row here only for a line someone chose to fill in or override.
 */
@Entity('trade_show_budget_line')
@Index('idx_trade_show_budget_line_show', ['tradeShowId', 'lineKey'])
export class TradeShowBudgetLineEntity extends BaseEntity {
	@Column('int', { name: 'fk_trade_show__id' })
	public tradeShowId!: number;

	@Column('varchar', { name: 'lineKey', length: 20 })
	public lineKey!: TradeShowBudgetLineKey;

	@Column('decimal', { name: 'attendAmount', precision: 10, scale: 2, nullable: true })
	public attendAmount?: string | null;

	@Column('decimal', { name: 'exhibitAmount', precision: 10, scale: 2, nullable: true })
	public exhibitAmount?: string | null;

	/** Paid so far, for what Team and Travel doesn't know about: dues, the booth. */
	@Column('decimal', { name: 'actualAmount', precision: 10, scale: 2, nullable: true })
	public actualAmount?: string | null;

	@Column('varchar', { name: 'notes', length: 500, nullable: true })
	public notes?: string | null;
}
